import BitsType from './BitsType';
import ReadonlyType from './ReadonlyType';
var wemogyTypes = {
    bits: BitsType,
    readonly: ReadonlyType
};
export default wemogyTypes;
//# sourceMappingURL=WemogyTypes.js.map